import React, { useRef } from 'react'
import { useAuthDataContext } from '../../../../_providers/Auth'
import Dropdown from '../../../partials/Dropdown'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'
import { Checkbox, FormControlLabel } from '@mui/material'

function Filter(props) {
    const setByDropdownRef = useRef(null)
    const contractorDropdownRef = useRef(null)

    const auth = useAuthDataContext()

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleDate = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleContractor = data => {
        let { id, type } = data || ''

        props.handleSearch('performer_id', id)
        props.handleSearch('performer_type', type)
    }

    const handleSetBy = data => {
        let { id, type } = data || ''

        props.handleSearch('creator_id', id)
        props.handleSearch('creator_type', type)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('date', '')
        setByDropdownRef.current.reset()
        contractorDropdownRef.current.reset()
        props.handleSearch('creator_id', '')
        props.handleSearch('performer_id', '')
        props.handleSearch('performer_type', '')
        props.handleSearch('creator_type', '')
        props.handleSearch('deadline', '')
        props.handleSearch('text', '')
        props.handleSearch('flagged', '0')
    }

    return (
        <form className="filter-standard schedule-filter">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1" selected>
                        {trans('labels.contractor')}
                    </option>
                    <option value="2">
                        {trans('labels.from')}
                    </option>
                    <option value="3">
                        {trans('labels.to')}
                    </option>
                    <option value="4">
                        {trans('labels.search')}
                    </option>

                </select>
            </div>
            <div className="col" data-id="1">
                <input
                    id="search"
                    type="search"
                    name="text"
                    value={props.data.text}
                    onChange={handleSearch}
                    placeholder={trans('labels.search')}
                />
            </div>
            {auth.isManager()
                ?
                <>
                    <div className="col" data-id="2">
                        <Dropdown
                            url="todos/creators-performers"
                            inputIdValue={props.data.creator_id ? Number(props.data.creator_id) : ''}
                            renderText={data => {
                                return data.name
                            }}
                            onChange={handleSetBy}
                            inputPlaceholder={trans('random.setBy')}
                            ref={setByDropdownRef}
                        />
                    </div>
                    <div className="col" data-id="3">
                        <Dropdown
                            url="todos/creators-performers"
                            inputIdValue={props.data.performer_id ? Number(props.data.performer_id) : ''}
                            renderText={data => {
                                return data.name
                            }}
                            onChange={handleContractor}
                            inputPlaceholder={trans('labels.contractor')}
                            ref={contractorDropdownRef}
                        />
                    </div>
                </>
                :
                ''
            }
            <div className="col" data-id="4">
                <select
                    name="priority_id"
                    value={props.data.priority_id}
                    onChange={handleSearch}
                >
                    <option value="" selected>
                        {trans('random.allPriorities')}
                    </option>
                    <option value="1">
                        {`${trans('random.low')} ${trans('random.prioroty')}`}
                    </option>
                    <option value="2">
                        {`${trans('random.mid')} ${trans('random.prioroty')}`}
                    </option>
                    <option value="3">
                        {`${trans('random.high')} ${trans('random.prioroty')}`}
                    </option>
                </select>
            </div>
            <div className="col" data-id="4">
                <DateRange
                    startDate={props.data.date}
                    endDate={props.data.deadline}
                    onStartDateChange={(date) => {
                        props.handleSearch('date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('deadline', date)
                    }}
                />
            </div>
            {/* //NEW: Добавяне на филтър за флаг */}
            <div className="col" data-id="5">
                <FormControlLabel
                    control={
                        <Checkbox
                            id="flagged"
                            name="flagged"
                            checked={props.data.flagged === '1'}
                            onChange={e => props.handleSearch('flagged', e.target.checked ? '1' : '')}
                            size="small"
                        />
                    }
                    label={trans('labels.onlyFlagged')}
                />
            </div>
            <div className="col" data-id="6">
                <FormControlLabel
                    control={
                        <Checkbox
                            id="completed"
                            name="completed"
                            checked={props.data.completed === '0'}
                            onChange={e => props.handleSearch('completed', e.target.checked ? '0' : '')}
                            size="small"
                        />
                    }
                    label={trans('labels.onlyUncompleted')}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>
        </form>
    )
}

export default Filter